/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from '@mui/material';
import Button from '../../components/button';
import { ButtonColor } from './types';

type OmitProps = 'title' | 'error';

interface Props extends Omit<DialogProps, OmitProps> {
  title?: string;
  error?: boolean;
  negative?: string;
  positive?: string;
  positivetextcolor?: ButtonColor;
  onPositive: () => void;
  onNegative?: () => void;
  disabled?: boolean;
}

/** @deprecated in favor of components/modals/confirm-modal */
export default function CustomConfirmDialog({
  onPositive, onNegative, title, error, disabled = false, ...props
}: Props) {
  return (
    <div>
      <Dialog
        {...props}
        maxWidth={props.maxWidth ?? 'xs'}
        fullWidth
        open={props.open}
        onClose={onNegative}
        disableEnforceFocus
      >
        <DialogTitle
          data-testid="confirm-dialog-title"
          sx={{ fontWeight: 700, marginLeft: '7px' }}
        >
          {title}
        </DialogTitle>
        <DialogContent data-testid="confirm-dialog-description">
          {props.children}
        </DialogContent>
        <DialogActions>
          {error ? (
            <Button color="neutral" onClick={onNegative}>
              {props.negative ?? 'Close and try again'}
            </Button>
          ) : (
            <>
              {onNegative && (
                <Button color="neutral" onClick={onNegative}>
                  {props.negative ?? 'Cancel'}
                </Button>
              )}
              <Button
                onClick={onPositive}
                disabled={disabled}
                color={props.positivetextcolor || 'primary'}
                autoFocus
              >
                {props.positive ?? 'Okay'}
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
